module.exports = __webpack_public_path__ + "static/arrow-pink-bf4dc7e4d2e43b877a7896e77ae47071.png";